import { ContentRenderer } from "@/lib/content/ContentRenderer";
import { Checkbox } from "@mantine/core";
import { SyllabusPoint } from "@tsTypes/subject-schema";
import clsx from "clsx";
import { pointSyllabusSelection } from "../../../../../../features/syllabus/subjectSyllabusChecklistSlice";
import { AppDispatch } from "../../../../../store";
import classes from "./PointInput.module.css";

export default function PointInput({
  point,
  subjectDocumentId,
  topicDocumentId,
  subTopicDocumentId,
  isChecked,
  dispatch,
  restrictAccess,
  isComplete,
}: {
  point: SyllabusPoint;
  subjectDocumentId: string;
  topicDocumentId: string;
  subTopicDocumentId: string;
  isChecked: boolean;
  dispatch: AppDispatch;
  restrictAccess: boolean;
  isComplete: boolean;
}) {
  return (
    <Checkbox
      variant="outline"
      color={isComplete ? "darkblue" : "lightblue"}
      checked={isChecked}
      size="xs"
      label={
        <div>
          <b>{point.SyllabusPointNumber}:&nbsp;</b>
          <ContentRenderer content={point.Point} />
        </div>
      }
      classNames={{
        root: classes.root,
        labelWrapper: classes.labelWrapper,
        label: clsx(classes.label, restrictAccess && classes.labelDisabled),
        input: clsx(classes.input, restrictAccess && classes.inputDisabled),
      }}
      onChange={() => {
        if (restrictAccess) {
          return;
        }
        dispatch(
          pointSyllabusSelection({
            subjectDocumentId,
            topicDocumentId,
            subTopicDocumentId,
            pointDocumentId: point.documentId,
          })
        );
      }}
    />
  );
}
